import { clinicApi } from "@/domains/multi/clinicApi";
import { mapClinicSubscriptionToBillingSummary } from "@/domains/multi/mapClinicSubscriptionToBillingSummary";
import type { BillingSubscriptionSummary } from "@/domains/subscription/billingHelpers";

export type CheckoutBillingUser = {
    activeClinicId?: string | null;
    isMainManager?: boolean | null;
    subscriptionPlan?: string | null;
    subscriptionEndsAt?: string | null;
};

export async function fetchCheckoutBillingSubscription(
    user?: CheckoutBillingUser | null,
): Promise<BillingSubscriptionSummary> {
    const { data } = await clinicApi.getSubscription();
    const mapped = mapClinicSubscriptionToBillingSummary(data, user);
    if (mapped) {
        return mapped;
    }

    throw new Error("Clinic subscription summary unavailable");
}
